// src/components/Dashboard/Cards/StudentInsightsCard.jsx

import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import DashboardCard from './DashboardCard'; // Adjust path if needed

const StudentInsightsCard = ({ onHide }) => {
  // Define term and year as variables
  const term = 'Fall';
  const year = '2025';
  const termYear = `${term} ${year}`;

  const [stats, setStats] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // Helper function to format text with blue underlined term and year
  const formatText = (text) => {
    // Create a regular expression to match the term and year dynamically
    const regex = new RegExp(`(${term}\\s+${year})`, 'g');
    return text.split(regex).map((part, index) =>
      regex.test(part) ? (
        <span key={index} className="underline text-blue-500">
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  useEffect(() => {
    // Replace this with your real API call
    const fetchStats = async () => {
      setIsLoading(true);
      try {
        // Example static data (replace with actual data)
        const data = [
          {
            id: 'stat1',
            title: 'New plan comments',
            value: 7,
          },
          {
            id: 'stat2',
            title: `Students with unavailable planned courses for ${termYear}`,
            value: 4,
          },
          {
            id: 'stat3',
            title: `Students with abandoned courses in their cart for ${termYear}`,
            value: 6,
          },
          {
            id: 'stat4',
            title: `Incoming students without a plan for ${termYear}`,
            value: 0,
          },
        ];

        // Simulate a small delay
        await new Promise((resolve) => setTimeout(resolve, 500));

        setStats(data);
      } catch (error) {
        console.error('Error fetching student insights:', error);
        toast.error('Failed to load student insights.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchStats();
  }, [termYear]);

  return (
    <DashboardCard
      title={
        <span className="font-medium">
          Student Insights
        </span>
      }
      onHide={onHide}
      isLoading={isLoading}
    >
      {!isLoading &&
        (stats.length > 0 ? (
          <div className="flex space-x-4 overflow-x-auto">
            {stats.map((item) => (
              <div
                key={item.id}
                className="cursor-pointer bg-white dark:bg-gray-800
                           border border-gray-300 dark:border-gray-700
                           rounded-lg p-2 w-1/4 flex flex-col justify-between
                           relative transition-all duration-300"
              >
                <h5 className="text-sm font-medium text-gray-600 dark:text-gray-400 mb-2">
                  {formatText(item.title)}
                </h5>
                <div className="flex items-center text-sm text-gray-900 dark:text-white">
                  <p className="text-base font-bold">{item.value}</p>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center py-5">
            <p className="text-gray-600 dark:text-gray-400 mb-3">
              {formatText(`No insights available for ${termYear}.`)}
            </p>
          </div>
        ))}
    </DashboardCard>
  );
};

export default StudentInsightsCard;
